module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Francine Pascal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Francine Pascal is the creator of several bestselling series, including Fearless and Sweet Valley High, which was also made into a television series. She has written several novels, including "), _c('I', [_vm._v("My First Love and Other Disasters")]), _vm._v(", "), _c('I', [_vm._v("My Mother Was Never a Kid")]), _vm._v(", and "), _c('I', [_vm._v("Love & Betrayal & Hold the Mayo")]), _vm._v(". She is also the author of "), _c('I', [_vm._v("Sweet Valley Confidential: Ten Years Later")]), _vm._v(". She lives in New York and the South of France.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/b6FRuF/tc-custom/9780743434126.jpg?1730526156022",
      "alt": "This image is the cover for the book Heat, Fearless"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heat, Fearless\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Everyone longs for something. "), _c('br'), _vm._v(" And everyone gives in to temptation sometimes. "), _c('br'), _vm._v(" Mary. "), _c('br'), _vm._v(" Heather. "), _c('br'), _vm._v(" Sam. "), _c('br'), _vm._v(" Now it's my turn.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon Pulse\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0